import { notification } from 'antd';
export const toastError = async (errorTitle, errorMesage) => {
  await notification.error({ message: errorTitle, description: errorMesage });
};
